/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    import IPagedResultsColumns = Meevo.Components.BaseClasses.IPagedResultsColumns;
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;
    import MassUpdateActionEnum = Meevo.Model.MassUpdateActionEnum;
    import PriceCategoryEnum = Meevo.Model.PriceCategoryEnum;

    interface ISave extends IPagerModel {
        revertLocation: boolean,
        products: Array<any>,
        id?: string,
        scheduledDate?: Date,
        priceGroupId: any
    }

    interface IProductMassUpdateCriteria {
        massUpdateAction: MassUpdateActionEnum,
        amount: number,
        isPercent: boolean,
        priceCategory: PriceCategoryEnum,
        round: RoundPricesEnum | null
    }

    interface IProductCategoryCriteria{
        CatId: string;
    }

    interface IProductSubCategory {
        displayName: string,
        entityVersion: number,
        homeLocationId: number,
        id: string,
        languageId: number,
        locationId: number,
        objectCreationType: number,
        objectState: number
    }

    interface IFilterSortAndDetails {
        details: IDetails[];
        sort: ISort[];
    }

    interface IDetails {
        detailName: string;
        id: PriceCategoryEnum;
    }

    interface ISort {
        sortName: string;
        id: MassUpdateActionEnum;
    }

    interface IVariant {
        markUp: number | string;
        productDisplayName: string;
        productId: string;
        retail: string | number;
        sku: string;
        variantId: string;
        wholeSale: number;

    }

    export class ProductsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<ISave> {
        public disableCrud: boolean = true;
        public defaultFilterCriteria: any = {
            productCategoryId: undefined,
            manufacturerId: undefined,
            distributorId: undefined,
            excludeScheduled: this.isSchedulePriceShow() ? true : undefined,
            filter: undefined,
            productSubCategoryId: undefined
        };
        public filterCriteria: any = {... this.defaultFilterCriteria};
        public showFilteredItems: boolean = false;
        public isPreviewMassUpdate: boolean = false;
        public productCategory: any;
        public productSubCategory: IProductSubCategory;
        public productSubCategoryId: string;
        public productCategoryCriteria: IProductCategoryCriteria = { CatId: this.productCategory && this.productCategory.id };
        public manufacturer: any;
        public distributor: any;
        public amount: any;
        public massUpdateCriteria: IProductMassUpdateCriteria = {
            massUpdateAction: MassUpdateActionEnum.Decrease,
            amount: 0,
            isPercent: false,
            priceCategory: PriceCategoryEnum.Retail,
            round: null
        };
        public revertLocation: boolean = false;
        public scheduledDate?: Date;
        public isPriceManagement: boolean;
        public isSetOptionSelected: boolean = false;
        public isMarkupOptionSelected: boolean = false;
        public disableSwitch: boolean = true;
        public basePricingText: string = 'LABEL_BASE_PRICING_TO';
        public currentlyEditing = PriceCategoryEnum;

        public defaultCriteria() {
            return this.filterCriteria;
        }

        public filter: IFilterSortAndDetails = {
            details: [
                {
                    detailName: 'LABEL_WHOLESALE',
                    id: PriceCategoryEnum.Wholesale
                },
                {
                    detailName: 'LABEL_RETAIL',
                    id: PriceCategoryEnum.Retail
                },
                {
                    detailName: 'LABEL_MARKUP',
                    id: PriceCategoryEnum.Markup
                }
            ],
            sort: [
                {
                    sortName: 'LABEL_SET',
                    id: MassUpdateActionEnum.Set
                },
                {
                    sortName: 'LABEL_INCREASE',
                    id: MassUpdateActionEnum.Increase
                },
                {
                    sortName: 'LABEL_DECREASE',
                    id: MassUpdateActionEnum.Decrease
                }
            ]
        };

        constructor(protected params: Meevo.Model.ISectionParamsMarketPrice) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

            this.isPriceManagement = !this.identityService.inCentralOfficeMode();
            this.isPrimarySection = false;
        }

        public isSchedulePriceShow(): boolean {
            return this.params.contextService.getVisualState() === Model.MaintenanceFormVisualState.CustomSchedulePrice;
        }

        public get pagerBaseEndpoint(): string {
            if (!this.isPriceManagement) {
                return 'MarketPricing/Product/Preview';
            } else {
                return this.isSchedulePriceShow() ? 'PriceManagement/Queue/Product' : 'PriceManagement/Product';
            }
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.sectionModelRetrieved();
            this.takeBackup();
        }

        public changeProductCategoryId(productCategoryId: string): void {
            if (productCategoryId) {
                this.productCategoryCriteria.CatId = productCategoryId;
            } else {
                this.filterCriteria.productCategoryId = this.productCategoryCriteria.CatId = this.productSubCategory = this.filterCriteria.productSubCategoryId = null;
            }
            this.filterCriteria.productCategoryId = this.productCategory.id;
        }

        public checkSubCategoryId(productSubCategoryId: string): void {
            if (!productSubCategoryId) {
                this.filterCriteria.productCategoryId = this.productCategory.id;
            }
            this.filterCriteria.productSubCategoryId = productSubCategoryId;
        }

         /**
         * Restores the original model values which were stored at the time of load.
         * @returns {}
         */
        rollbackChanges(): void {
            _.extend(this.model, this.originalEntity);

            this.sectionModelRetrieved();
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            if (this.isSchedulePriceShow()) {
                this.filterCriteria.excludeScheduled = true;
            }
            this.postCancel();
        }

        selected(subSectionContentKey?: string): void {
            let data = this.params.contextService.sharedData;
            if(data && data.priceQueueItem) {
                this.applyDataForScheduled(data.priceQueueItem);
            }
            this.sectionModelRetrieved();
        }

        /**
         * When tab is lefted
         */
        public prevUnselected(): void {
            // Rollback sectionEndpoint
            this.sectionEndpoint = '';
            this.clearSection();

            super.prevUnselected();
        }


        public pagerOnPageLoaded() {
            let pages = this.model.pages;
            let currentPage = pages[this.model.currentPage];

            _.each(currentPage, (element: any) => {
                if(!this.isPreviewMassUpdate) {
                    if(element.retailScheduled) {
                        element.retailBase = element.retail;
                        element.retail = element.retailScheduled;
                    }
                    if(element.wholeSaleScheduled) {
                        element.wholeSaleBase = element.wholeSale;
                        element.wholeSale = element.wholeSaleScheduled;
                    }
                }
            });

            this.basePricingText = this.massUpdateCriteria.priceCategory === PriceCategoryEnum.Markup ? 'LABEL_BASE_PERCENT_TO' : 'LABEL_BASE_PRICING_TO';

            this.resetToDefaultValue();
            this.setMarkUpValue(pages);
            this.takeBackup();
        }

        setMarkUpValue(variants) {
            variants.map((variant: IVariant[]) => {
                variant.map((item: IVariant) => {
                    if (item.wholeSale > 0 && (Number(item.retail) / Number(item.wholeSale)) - 1 > 0)
                        item.markUp = ((Number(item.retail) / Number(item.wholeSale)) - 1).toFixed(4);
                    else
                        item.markUp = 0.0;
                })
            })
        }

        /**
         * Save
         * */
        public preSave(): any {
            if (!this.identityService.inCentralOfficeMode()) {
                this.sectionEndpoint = '';
            } else {
                this.sectionEndpoint = 'Product';
            }

            let model = {
                revertLocation: this.revertLocation,
            };

            if (this.scheduledDate) {
                model['scheduledDate'] = this.scheduledDate;
                model['priceGroupEntityTypeEnum'] = PriceGroupEntityTypeEnum.Product;
            }

            if (this.isPreviewMassUpdate) {

                // Create object for save Mass update
                this.model = <ISave>_.extend({}, model, {
                    productCategoryId: this.filterCriteria.productCategoryId,
                    manufacturerId: this.filterCriteria.manufacturerId,
                    distributorId: this.filterCriteria.distributorId,
                    massUpdateAction: this.massUpdateCriteria.massUpdateAction,
                    productSubCategoryId: this.filterCriteria.productSubCategoryId,
                    amount: this.massUpdateCriteria.isPercent ? this.amount * 100 : this.amount,
                    isPercent: this.massUpdateCriteria.isPercent,
                    priceCategory: this.massUpdateCriteria.priceCategory,
                    revertLocation: this.revertLocation,
                    filter: this.filterCriteria.filter,
                    priceGroupId: this.filterCriteria.priceGroupId ? this.filterCriteria.priceGroupId : null,
                    round: this.massUpdateCriteria.round
                });
            } else {
                let currentPage = this.model.pages[this.model.currentPage];
                let originalEntity = this.originalEntity;
                let originalCurrentPage = originalEntity.pages[this.model.currentPage];
                let save: ISave = _.extend({}, model,{
                    products: [],
                    priceGroupId: this.filterCriteria.priceGroupId ? this.filterCriteria.priceGroupId : null,
                });

                // Find changed items
                _.each(currentPage, (el: any, index) => {
                    let originalElement = originalCurrentPage[index];

                    if (el.wholeSale !== originalElement.wholeSale || el.retail !== originalElement.retail) {
                        el.oldWholeSale = el.wholeSale !== originalElement.wholeSale ? originalElement.wholeSale : undefined;
                        el.oldRetail = el.retail !== originalElement.retail ? originalElement.retail : undefined;
                        el.SKU = el.productDisplayName + ': ' + el.sku;

                        save.products.push(el);
                    }
                });

                this.model = save;
            }

            // Schedule Price Change
            if (this.filterCriteria.priceGroupId) {
                this.model['priceGroupId'] = this.filterCriteria.priceGroupId;
                this.model['priceGroupEntityTypeEnum'] = this.filterCriteria.priceGroupEntityTypeEnum;
                this.model['priceChangeStatusEnum'] = this.filterCriteria.priceChangeStatusEnum;
            }
        }

        public postAdd () {
            if (this.model && this.model['priceGroupId']) {
                this.applyDataForScheduled(this.model);
            }
        }

        /**
        * Clear data
        * */
        public postCancel(): void {
            this.isPreviewMassUpdate = false;

            this.filterCriteria.priceGroupId = this.parentItemId;
            this.filterCriteria.amount = null;
            this.filterCriteria.round = null;

            this.massUpdateCriteria = {
                massUpdateAction: MassUpdateActionEnum.Set,
                priceCategory: PriceCategoryEnum.Wholesale,
                amount: 0,
                isPercent: false,
                round: null
            }

            this.amount = 0;
            this.isSetOptionSelected = true;

            if (!this.filterCriteria.productCategoryId && !this.filterCriteria.productSubCategoryId) {
                this.productCategoryCriteria.CatId = null;
            }
        }

        public clearSection(): void {
            this.postCancel();

            this.showFilteredItems = false;

            this.scheduledDate = null;

            this.filterCriteria = {... this.defaultFilterCriteria};
        }

        public applyDataForScheduled(data) {
            this.scheduledDate = data.scheduleDate;
            this.filterCriteria.priceGroupEntityTypeEnum = data.priceGroupEntityTypeEnum;
            this.filterCriteria.priceChangeStatusEnum = data.priceChangeStatusEnum;
            this.filterCriteria.priceGroupId = data.priceGroupPriceQueueId ? data.priceGroupPriceQueueId : data.priceGroupId;
            this.filterCriteria.excludeScheduled = true;
        }

        resetToDefaultValue(): void {
            let isMarkupValue = this.filter.details.findIndex(item => item.id === PriceCategoryEnum.Markup) === -1;

            if (isMarkupValue) {
                this.filter.details.push({
                    detailName: 'LABEL_MARKUP',
                    id: PriceCategoryEnum.Markup
                })
            }
            this.basePricingText = 'LABEL_BASE_PRICING_TO';
            this.disableSwitch = true;
        }

        public setOptionMassUpdateActionCriteria(): void {
            this.isSetOptionSelected = this.massUpdateCriteria.massUpdateAction === MassUpdateActionEnum.Set;

            if (this.massUpdateCriteria.massUpdateAction !== MassUpdateActionEnum.Set && this.massUpdateCriteria.priceCategory === PriceCategoryEnum.Markup) {
                this.massUpdateCriteria.priceCategory = PriceCategoryEnum.Wholesale;
            }

            if (this.isSetOptionSelected) {
                this.resetToDefaultValue();
                this.massUpdateCriteria.isPercent = null;
                this.massUpdateCriteria.round = null;
            } else if (this.isSetOptionSelected && this.isMarkupOptionSelected){
                this.massUpdateCriteria.priceCategory = PriceCategoryEnum.Wholesale;
            } else {
                this.basePricingText = 'LABEL_BASE_PRICING_BY';
                this.disableSwitch = false;
                this.filter.details = this.filter.details.filter(item => item.id !== PriceCategoryEnum.Markup);
            }
        }

        public setOptionPriceCategoryCriteria(): void {
            this.isMarkupOptionSelected = this.massUpdateCriteria.priceCategory === PriceCategoryEnum.Markup;

            if (this.isMarkupOptionSelected) {
                this.massUpdateCriteria.isPercent = true;
                this.basePricingText = 'LABEL_BASE_PERCENT_TO';
            } else if (this.isSetOptionSelected) {
                this.massUpdateCriteria.isPercent = null;
                this.basePricingText = 'LABEL_BASE_PRICING_TO';
            }
        }

        public processPricings(variant: IVariant, currentlyEditing: PriceCategoryEnum) {
            if (currentlyEditing === PriceCategoryEnum.Wholesale) {
                if (variant.markUp == 0) {
                    variant.retail = variant.wholeSale;
                }
                else {
                    this.markUpProcess(variant);
                }
            }
            else if (currentlyEditing === PriceCategoryEnum.Retail) {
                this.markUpProcess(variant);
            }
            else if (currentlyEditing === PriceCategoryEnum.Markup) {
                if (variant.wholeSale > 0) {
                    variant.retail = (Number(variant.wholeSale) + (Number(variant.wholeSale) * Number(variant.markUp))).toFixed(2);
                }
            }
        }

        markUpProcess(variant: IVariant): void {
            if (variant.wholeSale > 0 && (variant.wholeSale <= variant.retail)) {
                variant.markUp = ((Number(variant.retail) - Number(variant.wholeSale)) / Number(variant.wholeSale)).toFixed(4);
            }
            else {
                variant.markUp = 0.0;
            }
        }
    }
}
